export default "__VITE_ASSET__BNEQGdSY__"